import { useAlertDialogStore } from 'src/domain/stores/useAlertDialogStore';
import type { ConfirmAlertProps } from 'src/presentation/helpers/types/AlertHelperTypes';

/**
 * Web sibling of AlertHelper. react-native-web's Alert is an empty function, so the two-button
 * confirm this app relies on never appeared and the flow behind it stalled -- adding an event from
 * a deeplink simply stopped, with nothing on screen to explain why.
 *
 * `window.confirm` would be the quick fix, but Chrome ignores it inside a cross-origin iframe,
 * which is how the app is embedded on topicusevents.nl/app. So the request is queued for
 * AlertDialog instead, a dialog that lives in the React tree and therefore works in the drawer as
 * well as standalone. Button labels survive the trip, which `window.confirm` could not do either.
 *
 * The defaults for the two labels stay in the dialog, so a queued request carries exactly what the
 * caller asked for.
 */
class AlertHelper {
	static showConfirmAlert({
		title,
		message,
		confirmText,
		cancelText,
		confirmButtonStyle,
		onConfirm,
		onCancel,
	}: ConfirmAlertProps) {
		useAlertDialogStore.getState().enqueue({
			kind: 'confirm',
			title,
			// The dialog leaves its message area out on null, so an absent message has to be null
			// rather than undefined -- otherwise it renders an empty block above the divider.
			message: message ?? null,
			confirmText,
			cancelText,
			isDestructive: confirmButtonStyle === 'destructive',
			onConfirm,
			onCancel,
		});
	}
}

export default AlertHelper;
